import React, { useEffect, useMemo, useState } from "react";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import Pagination from "../../../components/global/pagination/Pagination";
import columns from "../../../columns/cashDeposit/depositRequest/columns";
import ModalComponent from "../../../components/global/modal/ModalComponent";
import Eye from "../../../assets/Eye";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { Form, Input, Image, Spin, DatePicker } from "antd";
import {
  GetAllDepositRequestApi,
  AcceptRejectDepositRequestApi,
} from "../../../api/request/cashDeposit/depositRequest";
import moment from "moment";
import Segmented from "../../../components/segmented/Segmented.jsx";
import toast from "react-hot-toast";
import UserAvatar from "../../../components/global/avtar/UserAvatar.jsx";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";
import ExportHandler from "../../../components/global/export/ExportHandler.jsx";
import SummaryStatCards from "../../../components/global/SummaryStatCards.jsx";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const getDepositChargeSummary = (item) => {
  const requested = Number(item?.requestedAmount ?? item?.grossAmount) || 0;
  const percent = Number(item?.fee) || 0;
  const storedNet = Number(item?.amountToPay);
  const hasStoredNet =
    item?.amountToPay !== undefined &&
    item?.amountToPay !== null &&
    item?.amountToPay !== "" &&
    !(storedNet === 0 && percent === 0 && requested > 0);
  const net = hasStoredNet
    ? storedNet
    : percent > 0
      ? Math.round((requested - (requested * percent) / 100) * 100) / 100
      : requested;
  const safeNet = Number.isFinite(net) ? net : requested;
  const chargeAmount = Math.max(0, Math.round((requested - safeNet) * 100) / 100);
  const chargeText =
    percent > 0
      ? `${percent}% ($${chargeAmount.toFixed(2)})`
      : `$${chargeAmount.toFixed(2)}`;

  return {
    requested,
    net: safeNet,
    chargeText,
    netText: `$${safeNet.toFixed(2)}`,
    requestedText: `$${requested.toFixed(2)}`,
  };
};

const DepositRequest = () => {
  const depositRequestPermissions = useModulePermissions("wallet", "deposit");
  const canAcceptReject = !!depositRequestPermissions.accept_reject;
  const canExport = !!depositRequestPermissions.export;

  const [form] = Form.useForm();
  const [isReqLoading, setIsReqLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [data, setData] = useState([]);
  const [viewModalData, setViewModalData] = useState([]);
  const [filterDeposit, setFilterDeposit] = useState("Pending");
  const [isOpenModalimg, setIsOpenModalimg] = useState(false);
  const [isOpenProof, setIsOpenProof] = useState(false);
  const [dates, setDates] = useState([]);
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sorter, setSorter] = useState({
    SortBy: "requestDate",
    SortOrder: "descend",
  });
  const tableColumns = useMemo(
    () =>
      columns.map((column) =>
        column.sorter
          ? {
              ...column,
              sortOrder:
                sorter.SortBy === column.dataIndex
                  ? sorter.SortOrder || null
                  : null,
            }
          : column,
      ),
    [sorter],
  );
  const formatListDate = (value) => {
    if (!value) return "--";
    const date = moment(value);
    if (!date.isValid() || date.year() <= 1900) return "--";
    return date.format("DD-MM-YYYY, hh:mm A");
  };
  const initialValues = {};

  const getFilterText = () =>
    filterDeposit === "Pending"
      ? "pending"
      : filterDeposit === "Approved"
        ? "approved"
        : filterDeposit === "Declined"
          ? "rejected"
          : filterDeposit;

  const getAllDepositRequest = async () => {
    setIsLoading(true);
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FilterText: getFilterText(),
        FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
        ...sorter,
      };
      const { data } = await GetAllDepositRequestApi(
        new URLSearchParams(params).toString(),
      );
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: (
                <UserAvatar
                  data={{
                    name: `${item?.firstName} ${item?.lastName}`,
                    email: item?.email,
                  }}
                />
              ),
              documentUrl: (
                <div>
                  <Image
                    src={item?.documentUrl?.[0]}
                    alt="document-img"
                    width={40}
                    height={40}
                    className="rounded-full object-cover"
                  />
                </div>
              ),
              grossAmount: item?.requestedAmount,
              charge: getDepositChargeSummary(item).chargeText,
              netAmount: getDepositChargeSummary(item).netText,
              requestedAmount:
                item?.depositType === "CashDeposit" &&
                filterDeposit === "Approved"
                  ? item?.acceptedAmount
                  : item?.requestedAmount,
              requestDate: formatListDate(item?.requestDate),
              actionBy: item?.actionBy || "--",
              actionDate: formatListDate(item?.actionDate),
              actions: (
                <button
                  onClick={() => {
                    const summary = getDepositChargeSummary(item);
                    setIsView(true);
                    setViewModalData({
                      ...item,
                      grossAmount: item?.requestedAmount,
                      charge: summary.chargeText,
                      netAmount: summary.netText,
                    });
                    form.setFieldValue("amount", summary.net);
                  }}
                >
                  <Eye />
                </button>
              ),
              status:
                item?.status == "Approved" ? (
                  <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
                    {item?.status}
                  </span>
                ) : (
                  <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
                    {item?.status}
                  </span>
                ),
            };
          }),
        );
        setTotalRecord(data?.totalRecords);
        setTotalDeposit(data?.totalDeposit || 0);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const field = Array.isArray(sorter) ? sorter[0]?.field : sorter?.field;
    const order = Array.isArray(sorter) ? sorter[0]?.order : sorter?.order;
    if (field && order) {
      setSorter({ SortBy: field, SortOrder: order });
    } else {
      setSorter({ SortBy: "requestDate", SortOrder: "descend" });
    }
  };
  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      let params = {
        requestId: viewModalData?.requestId,
        amount: values?.amount,
        comment: values?.comment,
        status: 2,
      };
      const { data } = await AcceptRejectDepositRequestApi(params);
      if (data?.success) {
        form?.resetFields();
        setIsAccept(false);
        setIsView(false);
        getAllDepositRequest();
        toast.success(data?.message);
      }
      setIsLoading(true);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };

  const RequestHandlerRejected = async (value) => {
    if (!value) {
      if (!textAreaValue) {
        toast.error("Please enter a reason.");
        return;
      }
    }
    try {
      setIsReqLoading(true);
      let params = {
        requestId: viewModalData?.requestId,
        status: 3,
        comment: textAreaValue,
      };
      const { data } = await AcceptRejectDepositRequestApi(params);
      if (data?.success) {
        setIsReject(false);
        setIsView(false);
        getAllDepositRequest();
        toast.success(data?.message);
      }
      setTextAreaValue("");
      setIsReqLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsReqLoading(false);
    }
  };

  const exportHandler = async () => {
    try {
      let params = {
        ApplyPagination: false,
        searchText: searchText,
        FilterText: getFilterText(),
        FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
        SortBy: "requestDate",
        SortOrder: "descend",
      };
      const { data } = await GetAllDepositRequestApi(
        new URLSearchParams(params).toString(),
      );
      if (data?.success) {
        return {
          data: data?.data,
          removableColumns: ["userId", "requestId", "documentUrl"],
          fileName: "Deposit Request list",
        };
      } else {
        return { data: [], removableColumns: [] };
      }
    } catch (error) {
      return { data: [], removableColumns: [] };
    }
  };

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  useEffect(() => {
    getAllDepositRequest();
  }, [page, pageSize, filterDeposit, sorter, dates, searchText]);

  useEffect(() => {
    setPage(1);
  }, [filterDeposit, dates, searchText]);

  return (
    <>
      <div className="flex justify-between flex-wrap gap-5 items-center">
        <Segmented
          options={["Pending", "Approved", "Declined"]}
          value={filterDeposit}
          setValue={setFilterDeposit}
        />
        <div className="flex flex-wrap items-center gap-3">
          <RangePicker
            className="py-1.5 rounded-lg"
            format="DD-MM-YYYY"
            onChange={(dates) => setDates(dates || [])}
          />
          <div>
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={() => setSearchText(search)}
              prefix={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                    clipRule="evenodd"
                  />
                </svg>
              }
              suffix={
                search && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      setSearchText("");
                      setSearch("");
                    }}
                    viewBox="0 0 24 24"
                    fill="#bebebe"
                    className="size-5 cursor-pointer duration-300 hover:fill-[#969595]"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                      clipRule="evenodd"
                    />
                  </svg>
                )
              }
            />
          </div>
          {canExport && (
            <div>
              <ExportHandler exportHandler={exportHandler} />
            </div>
          )}
        </div>
      </div>

      <div className="my-6">
        <SummaryStatCards
          items={[
            {
              label: "Total Requests",
              value: totalRecord,
              theme: "blue",
            },
            {
              label: "Total Deposit",
              value: totalDeposit,
              isCurrency: true,
              theme: "green",
            },
          ]}
        />
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={tableColumns}
            data={data}
            loading={isLoading}
            onChange={handleTableChange}
            hiddenColumns={!canAcceptReject ? ["Actions"] : []}
            page={page}
            pageSize={pageSize}
          />
        </div>
        <Pagination
          total={totalRecord}
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
        />
      </div>

      <ModalComponent
        isOpen={isView}
        setIsOpen={setIsView}
        title="Deposit detail"
        width={1300}
      >
        <div className="sm:p-5 p-3">
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 ">
            <div>
              <p className="text-description font-normal ">First Name</p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.firstName}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Last Name</p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.lastName}
              </p>
            </div>
            <div>
              <p className="text-description font-normal">Email</p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.email}
              </p>
            </div>
            {/* <div>
              <p className='text-description font-normal '>Available Balance</p>
              <p className='text-xl primary font-semibold  mt-2'>$ 524</p>
            </div> */}

            <div>
              <p className="text-description font-normal ">Mobile No.</p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.phoneNo}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">
                Wallet Account No.
              </p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.walletAccountNo}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Balance</p>
              <p className="text-description primary font-semibold  mt-2">
                {viewModalData?.balance}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Requested amount</p>
              <p className="text-description primary font-semibold mt-2">
                $ {viewModalData?.grossAmount ?? viewModalData?.requestedAmount}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Fee (%)</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.charge || "$0.00"}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Amount to Pay</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.netAmount || "$0.00"}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Comment</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.comment}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Status</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.status}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Transaction ID</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.referenceId}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Request Date</p>
              <p className="text-description primary font-semibold mt-2">
                {formatListDate(viewModalData?.requestDate)}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Action By</p>
              <p className="text-description primary font-semibold mt-2">
                {viewModalData?.actionBy || "--"}
              </p>
            </div>
            <div>
              <p className="text-description font-normal ">Action Date</p>
              <p className="text-description primary font-semibold mt-2">
                {formatListDate(viewModalData?.actionDate)}
              </p>
            </div>
            {viewModalData.status === "Approved" ? (
              <div>
                <p className="text-description font-normal ">Accepted Amount</p>
                <p className="text-description primary font-semibold mt-2">
                  {viewModalData?.acceptedAmount || "0"}{" "}
                </p>
              </div>
            ) : (
              ""
            )}
            <div>
              <p className="text-[#1E232CC7] text-description">Document</p>
              <div
                className="flex items-center cursor-pointer"
                onClick={() => setIsOpenModalimg(true)}
              >
                <p className="primary text-description font-semibold mt-2 underline mr-2">
                  View Document
                </p>
              </div>
            </div>
            {Array.isArray(viewModalData?.proofOfFundUrl) && viewModalData.proofOfFundUrl.length > 0 && (
              <div>
                <p className="text-[#1E232CC7] text-description">Source of fund</p>
                <div
                  className="flex items-center cursor-pointer"
                  onClick={() => setIsOpenProof(true)}
                >
                  <p className="primary text-description font-semibold mt-2 underline mr-2">
                    View Source of fund
                  </p>
                </div>
              </div>
            )}
          </div>

          {viewModalData.status === "Pending" ? (
            <div className="flex justify-center items-center">
              {canAcceptReject && (
                <div className="mt-8">
                  <button
                    onClick={() => {
                      form.setFieldValue(
                        "amount",
                        getDepositChargeSummary(viewModalData).net,
                      );
                      setIsAccept(true);
                    }}
                    className="bg-[#2D9B6333] text-sm text-[#2D9B63] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#2D9B63] hover:text-white duration-500"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => setIsReject(true)}
                    className="bg-[#F8222333] text-sm text-[#F82223] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#F82223] hover:text-white duration-500 ml-4"
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </ModalComponent>

      {/* ---- Accept-request ---- */}
      <ModalComponent
        isOpen={isAccept}
        setIsOpen={setIsAccept}
        title="Accept deposit request"
        width={500}
      >
        <>
          <Form
            className="w-full"
            autoComplete="off"
            form={form}
            initialValues={initialValues}
            onFinish={handleSubmit}
          >
            <div className="mb-4 text-sm text-[#2F2B3DCC] space-y-1">
              <p>Requested amount: $ {viewModalData?.grossAmount ?? viewModalData?.requestedAmount}</p>
              <p>Fee (%): {viewModalData?.charge || "$0.00"}</p>
              <p>Amount to Pay: {viewModalData?.netAmount || "$0.00"}</p>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Amount credited to wallet
              </label>
              <Form.Item
                name="amount"
                rules={[{ required: true, message: "Please enter amount." }]}
              >
                <Input
                  type="number"
                  placeholder="amount"
                  className="mt-1 w-full ps-4 py-2"
                />
              </Form.Item>
            </div>
            <div className="input-white w-full mt-4">
              <label className="text-description text-[#2F2B3DCC] font-medium mb-2">
                Comment
              </label>
              <Form.Item
                name="comment"
                rules={[
                  { required: true, message: "Please enter your comment." },
                ]}
              >
                <TextArea
                  placeholder="comment"
                  className="mt-1 ps-4 py-2"
                  rows={3}
                />
              </Form.Item>
            </div>

            <div className="flex justify-center items-center gap-5 mt-5">
              <button
                type="button"
                onClick={() => setIsAccept(false)}
                disabled={isLoading}
                className="bg-[#D91819] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500"
              >
                No
              </button>
              <LoadableButton
                type="Submit"
                disabled={isLoading}
                className="bg-[#2D9B63] text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-[#096034] duration-500"
                lable="Yes"
                isLoading={isLoading}
                loadingLable="Accepting..."
              />
            </div>
          </Form>
        </>
      </ModalComponent>

      {/* ---- Reject-request ---- */}
      <ConfirmationModal
        isOpen={isReject}
        setIsOpen={setIsReject}
        message="Are you sure you want to reject this request?"
        onConfirm={() => RequestHandlerRejected(false)}
        isLoading={isReqLoading}
        loadingLabel="Rejecting request..."
        textArea={true}
        textAreaValue={textAreaValue}
        setTextAreaValue={setTextAreaValue}
        placeholder="Reason of rejection..."
      />

      {/* Source of fund */}
      <ModalComponent
        isOpen={isOpenProof}
        setIsOpen={setIsOpenProof}
        title="Source of fund"
        width={1000}
      >
        {Array.isArray(viewModalData?.proofOfFundUrl) && viewModalData.proofOfFundUrl.length > 0 ? (
          <div className="p-5">
            <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10">
              {viewModalData.proofOfFundUrl.map((url, index) => (
                <div key={index} className="border border-gray-300 rounded-lg">
                  {url.endsWith(".pdf") ? (
                    <iframe src={url} title={`Source of fund ${index + 1}`} className="w-full h-64 rounded-lg" />
                  ) : (
                    <img
                      src={url}
                      alt={`Source of fund ${index + 1}`}
                      className="w-full h-auto rounded-lg cursor-pointer"
                      onClick={() => openInNewTab(url)}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>No Source of fund available</p>
        )}
      </ModalComponent>

      {/* View Document */}
      <ModalComponent
        isOpen={isOpenModalimg}
        setIsOpen={setIsOpenModalimg}
        title="View Document"
        width={1000}
      >
        {isReqLoading ? (
          <div className="flex justify-center flex-col my-[10%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <div>
            {viewModalData?.documentUrl &&
            viewModalData.documentUrl.length > 0 ? (
              <div className="p-5">
                <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10">
                  {viewModalData.documentUrl.map((url, index) => (
                    <div key={index}>
                      <div className="border border-gray-300 rounded-lg">
                        {url.endsWith(".pdf") ? (
                          <div className="relative">
                            <div className="absolute bottom-2 right-2 z-10">
                              <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white text-xs font-medium px-3 py-2 rounded-md shadow"
                              >
                                View
                              </a>
                            </div>
                            <iframe
                              src={url}
                              title={`Deposit Document ${index + 1}`}
                              className="w-full h-64 rounded-lg"
                            />
                          </div>
                        ) : (
                          <img
                            src={url}
                            alt={`Deposit Document ${index + 1}`}
                            className="w-full h-auto rounded-lg cursor-pointer"
                            onClick={() => openInNewTab(url)}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <p>No documents available</p>
            )}
          </div>
        )}
      </ModalComponent>
    </>
  );
};

export default DepositRequest;
